// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { PlayerRow } from "@suns/api/generated-client/apollo";
import { AmateurPlayerAnalytics } from "./components/AmateurPlayerAnalytics";
import { NbaPlayerAnalytics } from "./components/NbaPlayerAnalytics";

export function PlayerAnalytics({
  player,
  print = false,
}: {
  player: PlayerRow;
  print?: boolean;
}) {
  const hasProData = Boolean(player.metadata[0]?.hybridGradeCurrent);
  const hasAmatuerData = Boolean(player.metadata[0]?.hybridGradeBullseye);

  const showAmateur = hasAmatuerData && !hasProData;

  return (
    <>
      {showAmateur ? (
        <AmateurPlayerAnalytics player={player} print={print} />
      ) : (
        <NbaPlayerAnalytics player={player} print={print} />
      )}
    </>
  );
}
